import KickClient from "./api";
import { getUserID } from "./visitCookies";

// One instance belongs to one mounted questionnaire. Keep suggestions in memory
// until the medication question opens; prefetching must not create an answer or
// mark anything confirmed. The question still reads fresh history before using
// a preview, so a revision or source-text change starts a new extraction.
export function createMedicationReviewPrefetch() {
  let cachedPreview;

  const loadPreview = (text, revision) => {
    const ownerUserID = getUserID();
    if (
      cachedPreview &&
      cachedPreview.ownerUserID === ownerUserID &&
      cachedPreview.text === text &&
      cachedPreview.revision === revision
    ) {
      return cachedPreview.request;
    }

    const request = KickClient.newAuthenticatedClient().post(
      "/visits/medications/preview",
      { text },
    );
    cachedPreview = { ownerUserID, text, revision, request };
    // A failed background attempt should be retried when the question opens.
    request.catch(() => {
      if (cachedPreview?.request === request) cachedPreview = undefined;
    });
    return request;
  };

  const prefetch = async (draft) => {
    const ownerUserID = getUserID();
    if (!ownerUserID || draft?.ownerUserID === ownerUserID) return;
    try {
      const { data } = await KickClient.newAuthenticatedClient().get(
        "/visits/medications",
      );
      if (getUserID() === ownerUserID && data.legacyText) {
        await loadPreview(data.legacyText, data.history.revision);
      }
    } catch {
      // Best effort: the question retains its normal loading, retry and manual
      // entry flow if either background request fails.
    }
  };

  return { prefetch, loadPreview };
}
